/**
 * Application Constants
 *
 * @author    Frontend Design Systems <FrontendDesignSystems@wayfair.com>
 * @copyright 2019 Wayfair LLC - All rights reserved
 */

export const applicationName = {
  INTRANET: 'intranet',
  EXTRANET: 'extranet',
  STORES: 'stores',
};
